import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { ConfettiIcon } from "@/shared/icons/ConfettiIcon";
import { CardSeparator } from "@/shared/Components/CardSeparator";
import type { FC } from "react";
import type { Dayjs } from "dayjs";
import type { BirthdayEvent } from "@/services/api";
import styles from "./styles.module.scss";
import { CalendarBirthdayCard } from "./components/calendar-birthday-card/CalendarBirthdayCard";

type CalendarEventListMobileProps = {
  date: Dayjs;
  events: BirthdayEvent[];
};

export const CalendarBirtdayListMobile: FC<CalendarEventListMobileProps> = ({ events, date }) => {
  const { t } = useTranslation();

  return (
    <ul className={classNames(styles["todo-list"], styles["anniversary-list"])}>
      <div className={styles["event-header"]}>
        <ConfettiIcon />
        <p className={styles["event-header-text"]}>{t("calendarPage.birthdayTextMobile")}</p>
      </div>
      {events.map((event) => {
        const id = event.personId;

        return <CalendarBirthdayCard key={id} type={event.type} id={id} currentDate={date} />;
      })}
      <CardSeparator />
    </ul>
  );
};
